import { connect } from 'react-redux';
import Search from './search-bar';
import { onSearch } from '../../../reducers/course.reducers';

const mapStateToProps = state => ({
  selectedCourseId: state.courses.selectedCourseId,
  isLoadingSearchResults: state.courses.isLoadingSearchResults,
  config: state.authentication.config,
});

const mapDispatchToProps = dispatch => ({
  search: (searchTerm) => {
    dispatch(onSearch(searchTerm));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/app/main/search/search-bar/search-bar.container.js